import { render } from "./echeck.vue?vue&type=template&id=2cad9aca&scoped=true"
import script from "./echeck.vue?vue&type=script&lang=js"
export * from "./echeck.vue?vue&type=script&lang=js"

import "./echeck.vue?vue&type=style&index=0&id=2cad9aca&scoped=true&lang=css"

import exportComponent from "/var/www/html/facturacion/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2cad9aca"]])

export default __exports__